module.exports = __webpack_public_path__ + "static/part-0-f92cb62e49378fb9267e29381ab07d87.svg";